/**
 * Base compartilhada da IA-API (única conexão no QG).
 * Paths de domínio: `${IA_API_BASE_URL}/centralamparo/...`, `/auth/login`, etc.
 *
 * Override opcional: VITE_IAAPI_BASE_URL (sem barra final)
 * Default: https://iaapi.portalpasi.com.br/api/v1
 */
function normalizeApiBase(raw: string): string {
  return raw.trim().replace(/\/$/, '')
}

export const IA_API_DEFAULT_BASE = 'https://iaapi.portalpasi.com.br/api/v1'

export const IA_API_BASE_URL = normalizeApiBase(
  import.meta.env.VITE_IAAPI_BASE_URL || IA_API_DEFAULT_BASE
)

/** Módulo Central Amparo na mesma base. */
export const IA_API_CENTRAL_AMPARO_BASE = `${IA_API_BASE_URL}/centralamparo`
